import { useReduxState } from '@engage/redux';
import { didDismissBookmarks } from '@members/notifications/redux';
import { useIsFreemiumMember } from '@members/tiering/hooks/useIsFreemiumMember';

export const useBookmarkPage = (pageName: string) => {
  const isFreemiumMember = useIsFreemiumMember();
  const dismissedBookmarks = useReduxState(didDismissBookmarks);

  return !dismissedBookmarks.includes(pageName) && !isFreemiumMember;
};
